export class Model {
    ID;
    constructor(jsonData) {
        this.ID = 0;
        Object.assign(this, jsonData)
    }
}